module.exports = __webpack_public_path__ + "jtails-build/img/another_banner@1.74bb066c.jpg";